var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "view-toolbar",
          attrs: { color: "primary", dark: "", tabs: "", flat: "", dense: "" },
        },
        [
          !_vm.drawerState
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-app-bar-nav-icon",
                              _vm._g(
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("toggle-drawer")
                                    },
                                  },
                                },
                                on
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3579378334
                  ),
                },
                [_c("span", [_vm._v("Open side menu")])]
              )
            : _vm._e(),
          _c("v-toolbar-title", { staticClass: "ml-2" }, [
            _vm._v(_vm._s(_vm.toolbarTitle)),
          ]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { icon: "", disabled: !_vm.hasChanged },
              on: {
                click: function ($event) {
                  return _vm.$emit("save")
                },
              },
            },
            [_c("v-icon", [_vm._v("save")])],
            1
          ),
        ],
        1
      ),
      _vm.hash === "NetworkDiagram"
        ? _c("CaseVisualization", {
            attrs: { "current-case": _vm.currentCase },
            on: {
              save: function ($event) {
                return _vm.$emit("save")
              },
              change: function ($event) {
                return _vm.$emit("change")
              },
            },
          })
        : _vm._e(),
      _vm.hash === "Map"
        ? [
            _vm.layersItems.length
              ? _c(
                  "v-toolbar",
                  { attrs: { flat: "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "mt-8", attrs: { sm: "4" } },
                      [
                        _c("v-select", {
                          attrs: {
                            label: "Projects Layers",
                            items: _vm.layersItems,
                            multiple: "",
                            chips: "",
                            disabled: !_vm.layersItems.length,
                            "item-text": "text",
                            "return-object": "",
                            dense: "",
                            placeholder: "All Projects",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "v-chip",
                                      _vm._b(
                                        {
                                          key: JSON.stringify(data.item),
                                          attrs: {
                                            "input-value": data.selected,
                                            disabled: data.disabled,
                                            color: data.item.color,
                                            small: "",
                                          },
                                          on: {
                                            "click:close": function ($event) {
                                              return data.parent.selectItem(
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        "v-chip",
                                        data.attrs,
                                        false
                                      ),
                                      [
                                        _vm._v(
                                          " " + _vm._s(data.item.text) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2179173474
                          ),
                          model: {
                            value: _vm.selectedLayers,
                            callback: function ($$v) {
                              _vm.selectedLayers = $$v
                            },
                            expression: "selectedLayers",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("VisGeo", {
              attrs: {
                "case-id": _vm.case_id,
                "case-name": _vm.case_name,
                projects: _vm.projects,
                nodes: _vm.nodes,
                branches: _vm.branches,
                outputs: _vm.SSEYearlyOutput,
                "map-layers": _vm.mapLayers,
                "start-year": this.currentCase
                  ? this.currentCase.settings.year_start
                  : "",
                offsetTop: _vm.layersItems.length,
              },
              on: {
                "add-map-layer": _vm.addMapLayer,
                "rename-map-layer": _vm.renameMapLayer,
                "remove-map-layer": _vm.removeMapLayer,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }